/* eslint-disable */
import StepBase from "../../common/StepBase";
import Helper from "../../common/Helper";

class StepMember extends StepBase {
  constructor(scene) {
    super(scene);

    this.setupCamera();
    this.setupMeshes();

    this.target = 0;
    this.targetMesh;

    this.changeMember(0);
    this.update();
  }

  //------------------------------------
  // Camera
  //------------------------------------
  setupCamera() {
    this.cameraRotationSpeed = -0.005;
    this.cameraPosition = new BABYLON.Vector3(0, 15, 45);
    this.cameraTarget = new BABYLON.Vector3(0, 10, 0);
  }

  //------------------------------------
  // Mesh
  //------------------------------------
  setupMeshes() {
    //Mesh Setting
    this.meshList.player_root = this.scene.getNodeByID("Player_root");
    this.meshList.player_root.position.y = 10;

    this.meshList.human = this.scene.getNodeByID("Human");
    this.meshList.human.parent = this.meshList.player_root;
    this.scene.getNodeByID("Human_Bag").parent = this.meshList.human;
    this.scene.getNodeByID("Human_Bag_Fire_L").parent = this.meshList.human;
    this.scene.getNodeByID("Human_Bag_Fire_R").parent = this.meshList.human;
    this.scene.getNodeByID("Human_Bag_Nozzle_L").parent = this.meshList.human;
    this.scene.getNodeByID("Human_Bag_Nozzle_R").parent = this.meshList.human;

    this.meshList.pod = this.scene.getNodeByID("Pod_root");
    this.meshList.rocket = this.scene.getNodeByID("Rocket_root");

    //Default Transform
    this.meshList.human.position.x = 0;
    this.meshList.pod.position.x = 0;
    this.meshList.rocket.position.x = 0;
  }

  //------------------------------------
  // Setting
  //------------------------------------
  changeMember(number) {
    this.resetMember();

    this.target = number;

    switch (this.target) {
      case 0:
        this.targetMesh = this.meshList.human;
        break;
      case 1:
        this.targetMesh = this.meshList.pod;
        break;
      case 2:
        this.targetMesh = this.meshList.rocket;
        break;
    }

    this.targetMesh.setEnabled(true);
  }

  resetMember() {
    this.meshList.human.position.y = 100;
    this.meshList.pod.position.y = 100;
    this.meshList.rocket.position.y = 100;

    this.meshList.human.setEnabled(false);
    this.meshList.pod.setEnabled(false);
    this.meshList.rocket.setEnabled(false);
  }

  //------------------------------------
  // Update
  //------------------------------------
  update() {
    this.targetMesh.position = Helper.updateTransform(
      this.targetMesh.position,
      new BABYLON.Vector3(0, 0, 0),
      15
    );
  }
}
export default StepMember;
